import { FlexibleBlockProps, FlexibleBlockBrickAiAgent, FlexibleBlockTemplateAiAgent } from '@nx-frontend/shared/types';
import { getWrapperProps } from '@nx-frontend/shared/utils/blocks';
import { brickCommon } from './common';

export const getAiAgentBlockTemplate = (): FlexibleBlockProps<FlexibleBlockTemplateAiAgent>[] => {
  const brickAiAgent: FlexibleBlockBrickAiAgent = {
    ...brickCommon,
    mainBrick: true,
    brickType: 'ai-agent',
    brickName: 'ai brick',
    agentId: null,
    allowUserInputAfterResult: true,
  };

  const block: FlexibleBlockProps<FlexibleBlockTemplateAiAgent> = {
    title: '',
    wrapper: { ...getWrapperProps('custom'), showTitle: false },
    template: {
      type: 'ai-agent',
      view: 'basic',
    },
    bricks: [{ ...brickAiAgent, index: 0 }],
    className: [],
  };

  return [block];
};
